import {t} from '@lingui/core/macro';

import {iriToId} from 'shared/api/iriHelper';

import IServerAlertRule, {
    SERVER_ALERT_RULE_METRICS,
    ServerAlertRuleMetric,
    ServerAlertRuleOperator,
    ServerAlertRuleSeverity,
} from '../model/ServerAlertRule/IServerAlertRule';
import {IServerAlertRuleMetricOption} from '../model/ServerAlertRule/IServerAlertRuleRecommendations';

export const SERVER_ALERT_RULE_OPERATORS: ServerAlertRuleOperator[] = ['>', '<'];

export function getServerAlertRuleOperatorLabel(operator: ServerAlertRuleOperator): string {
    switch (operator) {
        case '<':
            return t`Меньше`;
        case '>=':
            return t`Больше или равно`;
        case '<=':
            return t`Меньше или равно`;
        default:
            return t`Больше`;
    }
}

export function normalizeServerAlertRuleOperator(operator: ServerAlertRuleOperator): ServerAlertRuleOperator {
    return operator === '<' || operator === '<=' ? '<' : '>';
}

export function getServerAlertRuleSeverityLabel(severity: ServerAlertRuleSeverity): string {
    return severity === 'critical' ? t`Критично` : t`Предупреждение`;
}

export function getServerAlertRuleMetricLabel(
    metricOptions: IServerAlertRuleMetricOption[] | undefined,
    metric: ServerAlertRuleMetric,
): string {
    return metricOptions?.find((option) => option.value === metric)?.label ?? metric;
}

export interface IGroupedServerAlertRules {
    items: IServerAlertRule[],
    firstCommonUuid: string | undefined,
    firstOwnUuid: string | undefined,
}

export function groupServerAlertRules(rules: IServerAlertRule[], serverUuid: string): IGroupedServerAlertRules {
    const commonRules = rules.filter((rule) => rule.server === null);
    const ownRules = rules.filter((rule) => iriToId(rule.server) === serverUuid);

    return {
        items: [...commonRules, ...ownRules],
        firstCommonUuid: commonRules[0]?.uuid,
        firstOwnUuid: ownRules[0]?.uuid,
    };
}

export type ServersAlertRulesHintVariant = 'noRules' | 'limitedMetrics';

const SERVERS_LOW_ALERT_RULES_LIMIT = 5;

export function getServersAlertRulesHintVariant(
    hasServers: boolean,
    alertRulesCount: number,
    alertRulesLimit: number,
): ServersAlertRulesHintVariant | null {
    if (!hasServers) {
        return null;
    }
    if (!alertRulesCount) {
        return 'noRules';
    }
    const isLimitLow = alertRulesLimit > 0 && alertRulesLimit <= SERVERS_LOW_ALERT_RULES_LIMIT;

    return isLimitLow && SERVER_ALERT_RULE_METRICS.length > alertRulesLimit ? 'limitedMetrics' : null;
}
